import React, { useEffect, useState } from "react";
import MainComponent from "../MainComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getMasterTaskPriorityAndStatusData,
  getProjectSummaryDetails,
  getTaskDetails,
  getXLStrategyPlanDetails,
} from "../../store/actions";
import "./reports.css";
import { Gantt } from "gantt-task-react";
import "gantt-task-react/dist/index.css";
import TaskSidebar from "../gtmExecution/TaskSidebar";
import keys from "../../utils/helpInfoKeys.json";
import Login from "../Login";
import SideNavHelpInfo from "../../utils/SideNavHelpInfo";
import { motion } from "motion/react";

const GanttChart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fetchProjectSummaryDetails = useSelector(
    (state) => state.fetchProjectSummaryDetails
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [viewMode, setViewMode] = useState("Week");
  const [isTaskSidebarOpen, setIsTaskSidebarOpen] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selctedId, setSelectedId] = useState("");
  const [taskType, setTaskType] = useState("");
  const [subTaskId, setSubTaskId] = useState("");
  const [mileStonesData, setMileStonesData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [priorityData, setPriorityData] = useState([]);
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  const getMasterTasksPriorityAndStatusDetails = useSelector(
    (state) => state.getMasterTasksPriorityAndStatusDetails
  );
  const closeTaskNav = () => {
    setIsTaskSidebarOpen(false);
  };

  useEffect(() => {
    if (fetchProjectSummaryDetails && fetchProjectSummaryDetails.tasks) {
      const tasks_data = fetchProjectSummaryDetails.tasks.map((task) => ({
        ...task,
        start: new Date(task.start),
        end: new Date(task.end),
      }));
      setTasks(tasks_data);
    }
  }, [fetchProjectSummaryDetails]);

  useEffect(() => {
    if (localStorage.getItem("bi_id") && localStorage.getItem("product_id")) {
      dispatch(
        getProjectSummaryDetails(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id"),
          true
        )
      );
      dispatch(
        getMasterTaskPriorityAndStatusData(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id"),
          localStorage.getItem("selectedfunction")
        )
      );
    }
  }, []);
  const handleBack = () => {
    navigate("/projectanalytics", { replace: true });
  };

  const handleClick = () => {
    navigate("/dashboard", { replace: true });
  };
  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };
  const handleTaskClick = (task_data) => {
    dispatch(getTaskDetails(task_data.id));
    setIsTaskSidebarOpen(true);
    setSelectedId(task_data.id);
    setSelectedData(task_data);
  };
  useEffect(() => {
    if (getMasterTasksPriorityAndStatusDetails) {
      const transformedStatusOptions =
        getMasterTasksPriorityAndStatusDetails.status_dt.map((status) => ({
          value: status,
          label: status,
        }));
      setStatusData(transformedStatusOptions);
      const transformedPriorityOptions =
        getMasterTasksPriorityAndStatusDetails.priority_dt.map((priority) => ({
          value: priority,
          label: priority,
        }));
      setPriorityData(transformedPriorityOptions);
      const transformedMilestoneOptions =
        getMasterTasksPriorityAndStatusDetails.milestone.map((mile) => ({
          value: mile.value,
          label: mile.label,
        }));
      setMileStonesData(transformedMilestoneOptions);
    }
  }, [getMasterTasksPriorityAndStatusDetails]);
  const content = (
    <>
      <motion.div
        style={{
          maxHeight: "calc(100vh - 100px)",
          overflowY: "auto",
          padding: "1rem",
        }}
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
        className="gantt-chart-container"
      >
        <div
          style={{
            fontSize: "var(--main-heading)",
            fontWeight: "var(--heading-font-weight)",
            overflowY: "auto",
          }}
        >
          Gantt Chart for Tasks
        </div>
        {selectedHelpInfoSidebar && <SideNavHelpInfo />}
        {tasks && tasks.length > 0 ? (
          <div className="gantt-chart-button">
            <button
              onClick={() => handleViewModeChange("Day")}
              className={viewMode === "Day" && "active"}
            >
              Day View
            </button>
            <button
              onClick={() => handleViewModeChange("Week")}
              className={viewMode === "Week" && "active"}
            >
              Week View
            </button>
            <button
              onClick={() => handleViewModeChange("Month")}
              className={viewMode === "Month" && "active"}
            >
              Month View
            </button>
            <button
              onClick={() => handleViewModeChange("Year")}
              className={viewMode === "Year" && "active"}
            >
              Year View
            </button>
          </div>
        ) : (
          <div>
            Insufficient Information to Display Gantt Charts. The Gantt charts
            cannot be displayed due to the following reasons: <br />
            Tasks have not been created. OR <br />
            Start and end dates for tasks are not updated.
          </div>
        )}
        {tasks && tasks.length > 0 && (
          <Gantt
            tasks={tasks}
            viewMode={viewMode}
            onClick={(taskId) => handleTaskClick(taskId)}
          />
        )}
        {isTaskSidebarOpen && (
          <TaskSidebar
            isNewTask={false}
            // selectedTaskMilestoneId={selctedId}
            breadcrumbs={"Gantt Chart > Tasks " + " > " + selectedData.name}
            subTaskId={subTaskId}
            setSubTaskId={(value) => setSubTaskId(value)}
            selectedTaskId={selctedId}
            statusData={statusData}
            mileStonesData={mileStonesData}
            priorityData={priorityData}
            onClose={closeTaskNav}
            taskType={taskType}
            setTaskType={(value) => setTaskType(value)}
            isSubTaskVisible={false}
          />
        )}
      </motion.div>
    </>
  );
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <MainComponent
        maincontent={content}
        showProducts={true}
        showSelector={true}
        showButtons={true}
        handleNext={handleClick}
        handleBackButton={handleBack}
        breadcrumbParent={"Reports"}
        breadcrumbChild={"Gantt Chart"}
        documentName={"Gantt Chart"}
        helpKey={keys["Gantt Chart"].Name}
        image={"none"}
      />
    );
  }
};

export default GanttChart;
